import React from 'react';
import { CA_ADDRESS, EXPLORER_URL } from '../../config/constants';

const Tokenomics: React.FC = () => {
    const features = [
        {
            emoji: '🎯',
            title: '100% Fair Launch',
            description: 'No presale, no VC, no insider allocations. Everyone buys on the same bonding curve on nad.fun.',
        },
        {
            emoji: '🔒',
            title: 'No Rug Pull',
            description: 'Liquidity is managed by the nad.fun bonding curve. No one can drain the pool — it\'s built into the protocol.',
        },
        {
            emoji: '🏊',
            title: 'Bonding Curve',
            description: 'Price is determined by supply and demand through nad.fun\'s bonding curve mechanism. Early ducks get the best prices.',
        },
        {
            emoji: '⚡',
            title: 'Monad Speed',
            description: 'Built on Monad for lightning-fast transactions and minimal gas fees. No more waiting for your quack to confirm.',
        },
    ];

    return (
        <section id="tokenomics" className="section">
            <h2 className="section-title">🦆 Fair Launch Tokenomics</h2>
            <p className="tokenomics-subtitle">
                $DUCK is launched through nad.fun's bonding curve — the fairest way to launch a memecoin.
                No hidden allocations. No team tokens. Just pure, community-driven quacking.
            </p>

            <div className="fairlaunch-grid">
                {features.map((feature, index) => (
                    <div key={index} className="fairlaunch-card glass-card">
                        <div className="fairlaunch-emoji">{feature.emoji}</div>
                        <h3 className="fairlaunch-title">{feature.title}</h3>
                        <p className="fairlaunch-desc">{feature.description}</p>
                    </div>
                ))}
            </div>

            {/* Key Info Banner */}
            <div className="fairlaunch-info glass-card">
                <div className="fairlaunch-info-row">
                    <div className="fairlaunch-info-item">
                        <span className="fairlaunch-info-label">Token Name</span>
                        <span className="fairlaunch-info-value">DUCK</span>
                    </div>
                    <div className="fairlaunch-info-divider" />
                    <div className="fairlaunch-info-item">
                        <span className="fairlaunch-info-label">Network</span>
                        <span className="fairlaunch-info-value">Monad</span>
                    </div>
                    <div className="fairlaunch-info-divider" />
                    <div className="fairlaunch-info-item">
                        <span className="fairlaunch-info-label">Launch Platform</span>
                        <span className="fairlaunch-info-value">nad.fun</span>
                    </div>
                    <div className="fairlaunch-info-divider" />
                    <div className="fairlaunch-info-item">
                        <span className="fairlaunch-info-label">Launch Type</span>
                        <span className="fairlaunch-info-value">Bonding Curve</span>
                    </div>
                </div>
                <a
                    href={`${EXPLORER_URL}/address/${CA_ADDRESS}`}
                    target="_blank"
                    rel="noreferrer"
                    className="fairlaunch-contract-link"
                >
                    View Contract on MonadScan →
                </a>
            </div>
        </section>
    );
};

export default Tokenomics;
